export default {
	"c79c05d3fa3206a781b597ac1444c875": "Click on the payment method on the order confirmation page of the mall",
	"134ea29c551500ad9cb61d1998a125a1": "Mall (address placed later)",
	"83a380521708e07e9bd1776d35b90a5e": "Mall cash register page - Order button",
	"3b9321997185c98f5f1949e10eb79f92": "Mall order confirmation page - Coupon retention pop-up window - Confirmation button",
	"1edb72db12e4a8d95025f03206e30904": "Accept and use",
	"a0ac001e96c907b65b5728aafb159a9c": "Click on the coupon on the mall's order confirmation page",
	"b4cc0ca6f230d4533072b4b589515a94": "\"User Purchase Agreement\"",
	"77174ec07d6a6ff24d2a46498447cae7": "No available vouchers",
	"9671f62d29868f3b1002ef0a17586993": "Please select the available vouchers",
	"d4dbfb3307f9c03f3991713bc17c67b5": "Click on the coupon on the mall order confirmation page",
	"9b235059c79512ff2ce38754c6cd1f2a": "Give up"
}
